import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import ErrorHandler from "../../controls/ErrorHandler";
import { ErrorBoundary } from 'react-error-boundary';
import { Spinner, Table } from 'react-bootstrap';
//import 'bootstrap/dist/css/bootstrap.min.css';
import Icon from "../../controls/Icons/Icon";
import { dateDisplayFormater } from "../../../Utils";
//import jsPDF from "jspdf";
//import html2canvas from "html2canvas";


export default function InvoiceReport({ _inputValue, _invNumber }) {
    const [searchParams] = useSearchParams();
    const menuRef = useRef(null);
    const [Loading, setLoading] = useState(true);
    const state = useSelector(state => state);
    const [pdfdata, setpdfdata] = useState({
        ClientId: 0,
        ClientName: "",
        ClntAddress: "",
        ClntCity: "",
        ClntPhoneNumber: "",
        ClntState: "",
        ClntZipCode: "",
        CreatedDate: "",
        FmsAddress: "",
        FmsFederalTaxId: "",
        FmsId: "",
        FmsName: "",
        FmsPaypalId: "",
        FmsPhoneNumber: "",
        FmsZipCode: "",
        InvTransDetails: [],
        InvoiceId: "",
        InvoiceNumber: "",
        UpdateDate: "",
        UCINumber: "",
        TotalHours: "",
        InvAmount: "",
        InvoiceOwner: "",
        InvOwnerContactNumber : "",

    });

    const [invTransactionDetails, setinvTransactionDetails] = useState({
        Amount: 0,
        CreatedDate: "",
        MeetingDate: "",
        InvDescription: "",
        Rate: "",
        TotalHours:"",
    })
   
    
    useEffect(() => {

        if (_inputValue > 0) {
            setLoading(true);
            fetch(state.projectdetail.API + "/invoicePDF/Get?id=" + _inputValue, {
                method: "Get"
            }).then(response => response.json()).then((res) => {
                if (res) {
                    setpdfdata(res);
                    if (res.InvTransDetails && res.InvTransDetails.length > 0) {
                        setinvTransactionDetails(res.InvTransDetails);
                    }
                }
                else {
                    window.alert('Something went wrong', function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                }

            }).catch((err) => {
                if (err && err.name === 'AbortError') return;
                window.HandleError("InvoiceEditApproval.js ==> Invoice Get", null, null, err);
                console.log(err)
            }).finally(() => {
                setLoading(false);
                //setTimeout(() => {
                   // downloadPdf();
                //}, 500);

            });
        }

    }, [_inputValue]);
    //useEffect(() => {
    //    // wait for render
    //    setTimeout(() => {
    //        downloadPdf();
    //    }, 500);
    //}, []);

    const downloadPdf = async () => {
        //GeneratePDF
        if (_inputValue > 0) {
            setLoading(true);
            fetch(state.projectdetail.API + "/invoicePDF/GeneratePDF?id=" + _inputValue, {
                method: "Get"
            }).then(response => response.json()).then((res) => {
                if (res) {
                    window.alert('Pdf Invoice has been generated successfully', function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                }
                else {
                    window.alert('Something went wrong', function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                }

            }).catch((err) => {
                if (err && err.name === 'AbortError') return;
                window.HandleError("InvoiceEditApproval.js ==> Invoice Get", null, null, err);
                console.log(err)
            }).finally(() => {
                setLoading(false);
                //setTimeout(() => {
                // downloadPdf();
                //}, 500);

            });
        }

    }

    //const downloadPdf = async () => {

    //   // GeneratePDF


    //    const element = menuRef.current;

    //    const canvas = await html2canvas(element, {
    //        scale: 2
    //    });
    //    const imgData = canvas.toDataURL("image/png");

    //    const pdf = new jsPDF("p", "mm", "a4");

    //    const pdfWidth = pdf.internal.pageSize.getWidth();
    //    const pdfHeight =
    //        (canvas.height * pdfWidth) / canvas.width;

    //    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    //     let pdfsavePath = "C:\\JP\\ICC_PCP_V1.7\\PDFInvoiceReport\\" + pdfdata.InvoiceNumber +".pdf";
    //    //let pdfsavePath = pdfdata.InvoiceNumber + ".pdf";
    //    pdf.save(pdfsavePath);
        
    //};
   
    return (<ErrorBoundary FallbackComponent={ErrorHandler}>
        {Loading ? <div className="text-center"><Spinner as="span" animation="border" size="lg" role="status" aria-hidden="true" /> </div> :
            <div ref={menuRef}>
                {/*<Navbar expand="lg" ref={menuRef}>*/}
                {/*    <Container>*/}
                {/*        <Navbar.Brand>*/}
                {/*        <img src="../logo.png" className="logo" height="80px" /> <br />*/}
                {/*    </Navbar.Brand>*/}
                {/*    <img src="../logo.png" className="logo" height="80px" /> <br />*/}
                <Table>
                    <tr>
                        <td>
                            <img src="../logo.png" className="logo" height="80px" /> <br />
                        </td>
                    </tr>
                </Table>
                <Table bordered className="border border-2 border-dark">
                    <tr className="border border-1 border-dark">
                        <td md={6} className="border border-1 border-dark" >
                            <table><tr><td> 3647 Watseka Ave, Los Angeles, CA 90034 <br />

                                EIN: 83-280282 <br />

                                Phone: (310) 490-0008,  Email: sdpteam@iccintegradora.org <br /> </td></tr></table>

                        </td>
                        <td md={6} > &nbsp;
                        </td>
                    </tr>

                    <tr className="border border-1 border-dark" >
                        <td md={6} className="border border-1 border-dark">
                            <table><tr><td align='left'>
                                Please bill under Service Code: <br />
                                340-Independent Facilitator
                            </td></tr></table>

                        </td>
                        <td md={6} className="border border-1 border-dark">
                            <table><tr><td>
                                Invoice #  {_invNumber} <br />
                                Date: {dateDisplayFormater(pdfdata.CreatedDate)} <br />
                            </td></tr></table>
                        </td>
                    </tr>
                    <tr className="border border-1 border-dark" >
                        <td md={6} className="border border-1 border-dark">
                            <table><tr><td align='left'>
                                TO: {pdfdata.FmsName}  <br />
                                {pdfdata.FmsAddress}   <br />
                                {pdfdata.FmsZipCode}   <br />

                            </td></tr></table>

                        </td>
                        <td md={6} className="border border-1 border-dark">
                            <table><tr><td>
                                CLIENT: {pdfdata.ClientName}  <br />
                                UCI Number : {pdfdata.UCINumber} <br />
                            </td></tr></table>
                        </td>
                    </tr>
                </Table>
                <br />
                <Table bordered className="border border-1 border-dark">
                    <th className="border border-1 border-dark">DATE</th>
                    <th className="border border-1 border-dark">Description</th>
                    <th className="border border-1 border-dark">Code</th>
                    <th className="border border-1 border-dark">Hours</th>
                    <th className="border border-1 border-dark">Rate</th>
                    <th className="border border-1 border-dark">Amount</th>

                    {invTransactionDetails && invTransactionDetails.length > 0 &&
                        invTransactionDetails.map((rowdata, Index) => {
                            return (
                                <tr className="border border-1 border-dark">
                                    <td className="border border-1 border-dark"> {dateDisplayFormater(rowdata.MeetingDate)}</td>
                                    <td className="border border-1 border-dark"> {rowdata.InvDescription}</td>
                                    <td className="border border-1 border-dark"><center> 340 </center></td>
                                    <td className="border border-1 border-dark"><center>{rowdata.TotalHours}</center></td>
                                    <td className="border border-1 border-dark"><center>${rowdata.Rate}</center></td>
                                    <td className="border border-1 border-dark"><center> ${rowdata.Amount}</center></td>

                                </tr>

                            )
                        }
                        )

                    }
                    <tr>
                        <td className="border border-1 border-dark"> <b>Total</b></td>
                        <td className="border border-1 border-dark"></td>
                        <td className="border border-1 border-dark"></td>
                        <td className="border border-1 border-dark"><center>{pdfdata.TotalHours}</center></td>
                        <td className="border border-1 border-dark"></td>
                        <td className="border border-1 border-dark"><center>${pdfdata.InvAmount}</center></td>
                    </tr>

                </Table>

                <br />
                <br />
                <p style={{ color: '#0a4081' }}><b>I certify that this invoice accurately reflects the date, specific service/tasks performed and amount of time spent on each service/task and that the service/tasks are in accordance with state and federal requirements</b></p>
                <p> If you have any questions concerning this invoice, contact :Fernando Gomez, (310) 490-0008   </p>

                <p>Client approval and authorization for payment ________________________   Date  : _________________ </p>
                <br />
                <p style={{ color: 'blue', font: 'bold' }}><center>Thank you for your business! </center></p>

                {/*<p>*/}
                {/*    <Button variant="primary" onClick={downloadPdf}>*/}
                {/*        Save as PDF*/}
                {/*    </Button>*/}
                {/*</p>*/}
            </div>
        }
        </ErrorBoundary>

    )
}